import React from 'react';
import { useSelector } from 'react-redux';

import CourseFlowOverlay from 'components/CourseFlowOverlay/CourseFlowOverlay';
import { useFreecodeContextData, useFreecodeContextLayout, useFreecodeContextRun } from 'hooks/useContext';
import { editorTypes } from './FreecodeLayout/FreecodeLayoutConstants';
import { useQueryParams } from 'hooks/useQueryParams';
import services from 'api/services';
import { saveFlowProgressInLocalStorage } from 'functions/flowProgressInLocalStorageFunctions';

const { InputService } = services;

export default function FreecodeFlowOverlay({ animationAnchorRef = null }) {
  const { courseId } = useQueryParams();

  const { editorType } = useFreecodeContextLayout();
  const { testImpl, showFlowOverlay, setShowFlowOverlay, input, setInput } = useFreecodeContextData();
  const { levelToRun, selectLevelToRun, language } = useFreecodeContextRun();
  const { userId } = useSelector((state) => state.auth);

  const close = (userLevel) => {
    window.customPixiComponentForFlow = {};
    if (typeof userLevel === 'number' && editorType !== editorTypes.creator) selectLevelToRun(userLevel);
    setShowFlowOverlay(false);
  };

  const updateFlowProgress = async (data) => {
    try {
      if (editorType === editorTypes.creator) return;
      let inputExercise;
      if (userId) inputExercise = await InputService.updateFlowProgress(data);
      else inputExercise = saveFlowProgressInLocalStorage(data);
      setInput(inputExercise);
    } catch (e) {
      console.error('Error updating flow progress', e);
    }
  };

  return (
    showFlowOverlay && (
      <CourseFlowOverlay
        courseFlow={{
          levelIndexStart: levelToRun,
          courseId: courseId,
          testImpl,
          language,
        }}
        inputExercise={
          input?._id
            ? input
            : JSON.parse(localStorage.getItem(`fs-flow-progress-${testImpl.test}`) ?? JSON.stringify({ levelData: {} }))
        }
        isCreator={editorType === editorTypes.creator}
        updateFlowProgress={(data) => updateFlowProgress(data)}
        animationAnchorRef={animationAnchorRef}
        close={close}
      />
    )
  );
}
